import './orchestrators/duplicateEventOrchestrator';

export { duplicateEvent } from './actions/duplicateEvent';
